/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Encoding_ToastInputs */

const en_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding events to format...`)
};

const fr_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodage des événements au format...`)
};

const de_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse werden in ein Format kodiert...`)
};

const it_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica degli eventi nel formato...`)
};

const ru_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кодирование событий для форматирования...`)
};

const es_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificación de eventos al formato...`)
};

const zh_cn2_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件编码为格式...`)
};

const ja_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをフォーマットにエンコードしています...`)
};

const hi_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं को प्रारूप में एन्कोड करना...`)
};

const pt_pt2_subtitle_export_encoding_toast = /** @type {(inputs: Subtitle_Export_Encoding_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificando eventos para o formato...`)
};

/**
* | output |
* | --- |
* | "Encoding events to format..." |
*
* @param {Subtitle_Export_Encoding_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_encoding_toast = /** @type {((inputs?: Subtitle_Export_Encoding_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Encoding_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_encoding_toast(inputs)
	if (locale === "de") return de_subtitle_export_encoding_toast(inputs)
	if (locale === "it") return it_subtitle_export_encoding_toast(inputs)
	if (locale === "ru") return ru_subtitle_export_encoding_toast(inputs)
	if (locale === "es") return es_subtitle_export_encoding_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_encoding_toast(inputs)
	if (locale === "ja") return ja_subtitle_export_encoding_toast(inputs)
	if (locale === "hi") return hi_subtitle_export_encoding_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_encoding_toast(inputs)
	return en_subtitle_export_encoding_toast(inputs)
});